import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const KomokuKbn = props => {
  return <Dropdown.Static kubunKey='komoku_kbn' {...props} />
}
